import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Feedback } from '../../core/models/feedback';
import { FeedbackService } from '../../core/services/backend/feedback.service';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { ScrollViewWithBottomBarComponent } from '~/app/shared/components/scroll-view-with-bottom-bar.component';
import { NgClass } from '@angular/common';
import { AppButtonComponent } from '~/app/shared/components/app-button.component';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styles: `
    .selected-star {
      color: #ede381;
    }

    .dx-icon {
      cursor: pointer;
      font-size: 20px;
    }
  `,
  imports: [
    DxSelectBoxModule,
    DxTextBoxModule,
    TranslateModule,
    DxButtonModule,
    DxTextAreaModule,
    ScrollViewWithBottomBarComponent,
    NgClass,
    AppButtonComponent,
  ],
})
export class FeedbackComponent implements OnInit {
  public rating = 0;

  public formData: Feedback = new Feedback();

  public availableReasons = [
    {
      label: 'general',
      value: 'GENERAL',
    },
    {
      label: 'improvement',
      value: 'IMPROVEMENT',
    },
    {
      label: 'error',
      value: 'ERROR',
    },
  ];

  @Output() public closeFeedback = new EventEmitter();

  public feedbackService = inject(FeedbackService);
  public translate = inject(TranslateService);

  public ngOnInit() {
    this.reset();
  }

  public rated(val: number) {
    this.formData.rating = val;
  }

  public send() {
    this.feedbackService.post(this.formData).subscribe(() => {
      this.closeFeedback.emit();
      this.reset();
    });
  }

  public close() {
    this.reset();
    this.closeFeedback.emit();
  }

  public reset() {
    this.formData = new Feedback();
    this.rating = this.formData.rating;
  }

  selectRating(stars: number): void {
    this.rating = stars;
    this.formData.rating = stars;
  }
}
